import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";

const FilePreview = ({ open, onClose, file }) => {
  const fileType = file.fileType || file.type;
  const fileName = file.fileName || file.name;
  const downloadURL = file.downloadURL || file.downloadURL;

  const isPdf =
    fileType === "application/pdf" ||
    (fileName && fileName.toLowerCase().endsWith(".pdf"));
  const isImage = fileType && fileType.startsWith("image/");
  if (isImage) {
    console.log("isIMG: true");
  } else {
    console.log("isIMG: notrue");
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Preview: {fileName}</DialogTitle>
      <DialogContent dividers>
        {isImage ? (
          <Box
            component="img"
            src={downloadURL}
            alt={fileName}
            sx={{
              width: "100%",
              height: "auto",
              maxHeight: "70vh",
              objectFit: "contain",
            }}
          />
        ) : isPdf ? (
          <Box
            component="embed"
            src={downloadURL}
            type="application/pdf"
            width="100%"
            height="80vh"
          />
        ) : (
          <Typography variant="body1" color="textSecondary">
            Preview not available for this file type.
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FilePreview;
